import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const EditorInlineBoardIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={17}
        viewBox="0 0 16 17"
        className="Icon editor-inline-board"
        {...props}
    >
        <g fill="none">
            <rect width={14} height={14} x={1} y={1} fill="#47B9FF" fillRule="evenodd" rx={4} />
            <path
                fill="#323B4A"
                stroke="#FFF"
                strokeLinejoin="round"
                d="M8.5 7.5v6.707l-2.146-2.145c-1.443 1.25-2.673 2.571-2.858 4.002-.088.679.057 1.394.349 2.126-.523-.524-.966-1.182-1.306-1.997-.547-1.31-.618-2.524-.351-3.639.261-1.092.852-2.093 1.661-2.997L1.793 7.5H8.5z"
            />
        </g>
    </svg>
);
const Memo = memo(EditorInlineBoardIcon);
export default Memo;
